export const ADD_SNACKBAR = 'ADD_SNACKBAR';
const NEXT_SNACKBAR = 'NEXT_SNACKBAR';

const initialState = {
  current: '',
  messages: [],
};

export default (state = initialState, action) => {
  const { type, payload } = action;
  const { messages } = state;

  switch (type) {
    case ADD_SNACKBAR:
      return addMessage(state, payload);

    case NEXT_SNACKBAR:
      return messages.length
        ? { ...state, current: messages[0], messages: messages.slice(1) }
        : { ...state, current: '' };

    default:
      if (type.indexOf('REJECTED') >= 0 && payload.response) {
        return addMessage(state, payload.response.data);
      }
      return state;
  }
};

function addMessage(state, message) {
  const { current, messages } = state;

  if (!message) {
    return state;
  }
  return current ? { ...state, messages: [...messages, message] } : { ...state, current: message };
}

export function addSnackbar(message) {
  return { type: ADD_SNACKBAR, payload: message };
}

export function nextSnackbar() {
  return { type: NEXT_SNACKBAR };
}
